export default "__VITE_ASSET__OP4IGZJD__"